import { apiRecordsGet } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';
import {
  ADD_MEDICATIONS,
  FETCHING_MEDICATIONS,
  FETCHED_MEDICATIONS,
  UPDATE_PROJECT,
} from '../constants';

export const fetchMedications = (projectId: number | string) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId || projectId == null) return;
  dispatch({ type: FETCHING_MEDICATIONS, payload: true });
  try {
    const res = await apiRecordsGet(`/medications/get-all/${projectId}/${accountId}/${cognitoId}`);
    const data = res?.payload ?? res?.data ?? res;
    const list = Array.isArray(data) ? data : [];
    dispatch({ type: ADD_MEDICATIONS, payload: { project_id: String(projectId), list } });
    dispatch({ type: FETCHED_MEDICATIONS, payload: { project_id: String(projectId) } });
    dispatch({ type: UPDATE_PROJECT, payload: { id: projectId, medication_count: list.length } });
  } catch {
    dispatch({ type: ADD_MEDICATIONS, payload: { project_id: String(projectId), list: [] } });
    dispatch({ type: FETCHED_MEDICATIONS, payload: { project_id: String(projectId) } });
  } finally {
    dispatch({ type: FETCHING_MEDICATIONS, payload: false });
  }
};
